module.exports = __webpack_public_path__ + "img/Background9.1b34edc9.jpg";